var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 112 112"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.004) scale(1.00366)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.391,
    cy: 59.009,
    fill: "#f1f1f3",
    r: 14.523,
    transform: "matrix(3.83332 0 0 3.77387 -79.86 -166.679)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 56c6.446 0 11.667-5.221 11.667-11.667 0-6.445-5.221-11.666-11.667-11.666s-11.667 5.221-11.667 11.666C44.333 50.779 49.554 56 56 56zm0 5.833c-7.787 0-23.333 3.909-23.333 11.667v5.833h46.666V73.5c0-7.758-15.545-11.667-23.333-11.667z",
    fill: "#c2c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 56c6.446 0 11.667-5.221 11.667-11.667 0-6.445-5.221-11.666-11.667-11.666s-11.667 5.221-11.667 11.666C44.333 50.779 49.554 56 56 56zm0 5.833c-7.787 0-23.333 3.909-23.333 11.667v5.833h46.666V73.5c0-7.758-15.545-11.667-23.333-11.667z",
    fillOpacity: 0.25
  })))));
};
export default SvgAvatar;